import React from 'react';
import PropTypes from 'prop-types';
import { scroller } from 'react-scroll';
import humanFormat from 'human-format';
import { recordStatisticsEvent } from '../../../services/statistics-service';
import StyledTooltip from './styled-tooltip';

const CommentIcon = () => <span className="icon-lw icon-lw-comment" />;

export default function Comment({
  wire, fullWire, isOnROIPage, position,
}) {
  const fullLink = `/wires/${wire.slug}#comment_body`;

  const handleClick = () => {
    recordStatisticsEvent({
      event: 'wire_comment_click',
      statisticable: 'wire',
      id: wire.id,
      clicked_url: fullLink,
      page: window.location.pathname,
      custom_data: {
        section: 'all_wires',
        page: 'series',
        position,
      },
    });
  };

  const commentClicked = e => {
    e && e.preventDefault();
    handleClick();
    window.location = fullLink;
  };

  const scrollToComments = (scrollTarget, offset) => {
    scroller.scrollTo(scrollTarget, {
      // An offset is required to make the top of the element appear.
      // The comments section requires a greater offset than individual comments.
      offset,
      duration: 1500,
      smooth: 'easeInOutQuint',
    });
  };

  React.useEffect(() => {
    if (window.location.hash === '#comment_body') {
      scrollToComments('comment[body]', -200);
    } else if (/comment/.test(window.location.hash)) {
      // The .slice removes the '#' symbol as the start of the hash
      scrollToComments(window.location.hash.slice(1), -150);
    }
  }, []);

  if (isOnROIPage) {
    return (
      <StyledTooltip
        disableTouchListener
        title="Comment on wire"
        enterDelay={300}
      >
        <button type="button" className="comment-button" onClick={commentClicked}>
          {!!wire.commentCount && (
          <span className="count">
            { wire.commentCount ? humanFormat(wire.commentCount, { decimals: 1 }) : '\u00A0' }
          </span>
          )}
          <CommentIcon />
        </button>
      </StyledTooltip>
    );
  }
  return (
    <span className="comment-button">
      <span className="count">
        { wire.commentCount ? humanFormat(wire.commentCount, { decimals: 1 }) : '\u00A0' }
      </span>
      {
          fullWire
            ? <a href="#" onClick={() => scrollToComments('comment[body]', -200)}><CommentIcon /></a>
            : <a href={fullLink}><CommentIcon /></a>
        }
    </span>
  );
}

Comment.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    commentCount: PropTypes.number.isRequired,
  }).isRequired,
  fullWire: PropTypes.bool,
  isOnROIPage: PropTypes.bool,
  position: PropTypes.number,
};

Comment.defaultProps = {
  fullWire: false,
  isOnROIPage: false,
  position: null,
};
